<template>
  <div class="container" id="top">
    <Modal
      style="z-index: 1600"
      :agreeButton="false"
      title="新しいレッスンが解除されました！"
      ref="newlyGotLessonModal"
      :bodyScrollable="false"
      :bodyHeight="'400px'"
      :bodyWidth="'400px'"
      :overlay="false"
      :visibleNeverShowCheckbox="false"
    >
      <NewlyGotLessonBlock @go-to-new-lesson="goToNewLesson" :lesson="newlyGotLesson" />
    </Modal>
    <div style="flex: 1">
      <img src="@/assets/left-arrow.svg" width="20" class="back" @click="back" />
      <transition :name="transition_name">
        <div
          class="training-window"
          :class="[{ 'just-selected': justSelected }]"
          v-if="activeTraining"
        >
          <el-tooltip
            class="item"
            :open-delay="500"
            effect="dark"
            content="キーボードの矢印キー「←」でも移動できます"
            placement="top"
          >
            <div class="switch-button left" @click="switchToProb('prev')" v-show="current.index">
              <i class="el-icon-back" />
            </div>
          </el-tooltip>
          <el-tooltip
            class="item"
            :open-delay="500"
            effect="dark"
            content="キーボードの矢印キー「→」でも移動できます"
            placement="top"
          >
            <div
              class="switch-button right"
              @click="switchToProb('next')"
              v-show="current.index < selectedWorkbook.problems.length - 1"
            >
              <i class="el-icon-right" />
            </div>
          </el-tooltip>
          <img
            src="@/assets/play.svg"
            v-show="!isRecognizing"
            class="pause-icon"
            @click="resumeRecog"
          />
          <Score ref="scoreComponent" />

          <div class="window-inner" :class="{ sleep: !isRecognizing }">
            <div style>
              <div class="window-left">
                問題の{{ hasSpace("tet dis") ? "文章" : "単語" }}
                <img
                  src="@/assets/play.svg"
                  v-show="!showReadingHighlight"
                  @click="speak"
                />
                <img
                  src="@/assets/play-grey.svg"
                  v-show="showReadingHighlight"
                  style="cursor: default"
                />
                <div class="ss-control" @dblclick="setDefaultRate">
                  <img src="@/assets/turtle.svg" class="turtle" />
                  <div class="slide-container">
                    <input
                      v-model="rate"
                      type="range"
                      min="0.1"
                      max="1.1"
                      value="0.1"
                      step="0.01"
                      class="slider"
                    />
                  </div>
                  <img src="@/assets/rabbit.svg" class="rabbit" />
                </div>
              </div>
              <div class="window-right">
                <div style="display: flex; flex-wrap: wrap; justify-content: center">
                  <span
                    v-for="(word, index) in splitedProblemText"
                    style="margin-left: 6px"
                    :key="index"
                    class="text-color-transition"
                    :class="[
                      {
                        current:
                          index === currentReadingIndex && showReadingHighlight
                      },
                      {
                        'not-current':
                          index !== currentReadingIndex && showReadingHighlight
                      }
                    ]"
                  >{{ word }}</span>
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">モデル発音記号</div>

              <div class="window-right">
                <div
                  v-if="interimVisible || !result.modelOutput"
                  style="diplay: flex; flex-direction: row; flex-wrap: wrap;align-items: center; justify-content: center"
                >
                  <div
                    v-for="(word, index) in currentModelProns"
                    :key="index"
                    class="model-pron text-color-transition"
                    :class="[
                      {
                        current:
                          index === currentReadingIndex && showReadingHighlight
                      },
                      {
                        'not-current':
                          index !== currentReadingIndex && showReadingHighlight
                      }
                    ]"
                  >
                    <div v-for="ph in word">{{ ph.withStress }}</div>
                  </div>
                </div>

                <div v-if="!interimVisible && result" class="final speech-text">
                  <span
                    v-for="(r, index) in result.modelOutput"
                    :key="index"
                    style="display:inline-block; min-width: .5rem;position: relative"
                    :style="r.isRemoved ? 'color:#f88' : ''"
                    class="phoneme"
                    @click="goToOtherLessonPage(r.phonemeWithoutStress)"
                  >{{ r.isSpace ? " " : r.phoneme }}</span>
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">意味 / 発音難度</div>
              <div class="window-right" style="font-size: 1.2rem">
                <div style="display:flex; flex-wrap: wrap">
                  {{ current.problem.ja }}
                  <div
                    :style="
                      `color: #ffda75; ${
                        current.problem.ja ? 'margin-left: 20px' : ''
                      }`
                    "
                  >
                    <div v-for="i in 5" :key="i">
                      <span v-show="i <= current.problem.difficulty">★</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="flex: 1.3">
              <div class="window-left">
                ユーザー発音
                <img
                  src="@/assets/play.svg"
                  v-show="!interimVisible && !isUserPlaying"
                  @click="playLatestAudio"
                />
                <img
                  src="@/assets/play-grey.svg"
                  v-show="interimVisible || isUserPlaying"
                  style="cursor: default"
                />
              </div>
              <div class="window-right">
                <div
                  style="width: 100%; height: 100%; display:flex; flex-direction: column; justify-content: space-evenly; align-items:center;"
                >
                  <div
                    v-show="interimVisible"
                    class="interim speech-text"
                  >{{ interimTranscription }}</div>
                  <!-- <transition name="zoom-fade"> -->
                  <div v-show="!interimVisible" class="final speech-text">{{ finalTranscription }}</div>
                  <!-- </transition> -->
                  <ScoreGauge :currentScore="result.score" class="gauge" />
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">ユーザー発音記号</div>

              <div class="window-right">
                <transition name="fade">
                  <span v-if="!interimVisible && result" class="final speech-text">
                    <span
                      v-for="(r, index) in result.userOutput"
                      :key="index"
                      style="display:inline-block; min-width: .3rem;"
                      :style="r.isAdded ? 'color:rgba(0, 50, 40, 0.6)' : ''"
                    >{{ r.isSpace ? " " : r.phoneme }}</span>
                  </span>
                </transition>
              </div>
            </div>
            <div>
              <div class="window-left">{{ isRecognizing ? "音声認識中" : "停止中" }}</div>
              <div class="window-right">
                <div class="state-indicator">
                  <Listening class="spinner" :color="indicatorState ? '#ddd' : '#f88'" />
                  <div
                    class="text"
                    :class="[
                      { listening: !indicatorState },
                      { waiting: indicatorState }
                    ]"
                  >{{ interimVisible ? "音声入力中" : "待機中" }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <span class="close-modal" v-if="activeTraining" @click="closeModal"></span>

      <h1>{{ `/${$route.query.category}/の発音を学ぶレッスン` }}</h1>

      <div class="header-container">
        <div class="header">
          <div>
            <img class="icon" src="@/assets/video-player.svg" />
            <h2 class="text">発音解説動画</h2>
          </div>

          <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
        </div>
      </div>

      <el-tooltip
        class="item"
        :open-delay="500"
        effect="dark"
        content="Webカメラを使って口元とレッスン映像と比較します"
        placement="top"
      >
        <button class="button white mirror-switch" @click="enableMirror">
          鏡モードをオン
          <img src="@/assets/user.svg" />
        </button>
      </el-tooltip>

      <Videos
        class="videos"
        :videos="videos"
        ref="video"
        @on-camera-error-to-index="onCameraError"
      />
      <div class="header-container">
        <div class="header">
          <div>
            <img class="icon" src="@/assets/pair.svg" />
            <h2 class="text">音声認識トレーニング</h2>
          </div>
          <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
        </div>
        <div class="training-acc">
          <div class="title">トレーニング累積スコア</div>
          <div class="score">
            <AnimatedNumber :value="Math.floor($store.state.userData.totalScore)" />
          </div>
        </div>
      </div>

      <div style="text-align: center; margin: 10px 0">
        <div class="workbook-type-container">
          <div
            class="workbook-type"
            :class="{ active: selectedWorkbook.id === workbook.id }"
            v-for="(workbook, id) in workbookList"
            :key="id"
            @click="selectWorkbook(workbook, id)"
          >
            <div class="text">
              {{
              createTitle({
              phoneme: workbook.pron,
              position: workbook.position
              })
              }}
            </div>
            <ProgressCircle
              class="progress"
              :centerColor="
                selectedWorkbook.id === workbook.id ? '#555' : 'white'
              "
              :percentage="calcWorkbookScore(workbook)"
            />
          </div>
        </div>
      </div>
      <div class="upper-config">
        <el-tooltip
          class="item"
          :open-delay="500"
          effect="dark"
          content="合格点は80点です"
          placement="top"
        >
          <el-checkbox size="medium" :border="true" v-model="autoNextProb">合格点のとき自動的に次の問題に移動する</el-checkbox>
        </el-tooltip>
      </div>
      <div style="margin: 20px 20px;">
        <content-loader
          :height="97"
          :width="800"
          :speed="2"
          v-if="!problemsLoaded"
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="15.23" y="20" rx="5" ry="5" width="132" height="40" />
          <rect x="310.23" y="20" rx="5" ry="5" width="299.64" height="40" />
          <rect x="162.23" y="20" rx="5" ry="5" width="132" height="40" />
        </content-loader>
        <div v-if="true">
          <ProblemBlock
            class="problem-block"
            v-for="(problem, index) in selectedWorkbook.problems"
            :problem="problem"
            :key="index"
            :selectedLesson="selectedLesson"
            :score="
              JSON.stringify(problemScores) !== '{}'
                ? problemScores[problem.word]
                : undefined
            "
            @click.native="showTraining({ problem, index })"
          />
        </div>
      </div>
    </div>

    <FooterNav />
  </div>
</template>

<script>
import pronDict from "@/utils/PronDictionary";
import SpeechRecognizer from "@/utils/SpeechRecognizer";
import SpeechSynthesizer from "@/utils/SpeechSynthesizer";
import { CLEAR_SCORE, LANG, iconType } from "@/constants";
import { sleep } from "@/utils/functions";
import { speechRecorder } from "@/utils/SpeechRecorder";
import Vue from "vue";

import { ContentLoader } from "vue-content-loader";
import { Loading } from "element-ui";

import firebase from "firebase/app";

import { db, storage } from "@/plugins/firebase";

import Modal from "@/components/Modal";
import VueConfetti from "vue-confetti";

Vue.use(VueConfetti);
// let loadingInstance = Loading.service();

const _ = require("lodash");

const correctSE = new Audio(require("@/assets/correct.mp3"));
const incorrectSE = new Audio(require("@/assets/incorrect.mp3"));

const videos = require("@/resources/videos");

import problemResultRepo from "@/utils/ProblemResultRepository";

export default {
  name: "Lesson",
  props: ["lesson"],
  components: {
    ProblemBlock: require("./ProblemBlock").default,
    Videos: require("./Videos").default,
    Score: require("./Score").default,
    FooterNav: require("./FooterNav").default,
    NewlyGotLessonBlock: require("./NewlyGotLessonBlock").default,
    Listening: require("@/components/Listening").default,
    ProgressCircle: require("@/components/ProgressCircle").default,
    Modal: require("@/components/Modal").default,
    ScoreGauge: require("./ScoreGauge").default,
    AnimatedNumber: require("@/components/AnimatedNumber").default,
    ContentLoader,
  },
  computed: {
    calcWorkbookScore: function () {
      self = this;
      return function (workbook) {
        const problems = workbook.problems;
        const scores = problems.map((problem) => {
          if (self.problemScores[problem.word]) {
            return self.problemScores[problem.word];
          }
        });
        const cleared = scores.filter((score) => {
          return score !== undefined && score >= 80;
        });
        if (cleared && problems) {
          return Math.ceil((cleared.length / problems.length) * 100);
        }
      };
    },
    splitedProblemText() {
      return this.current.problemText.split(" ");
    },
    autoNextProb: {
      get() {
        return this.$store.state.autoNextProb;
      },
      set(val) {
        this.$store.commit("setAutoNextProb", val);
      },
    },
    indicatorState() {
      return this.interimVisible;
    },
  },
  data() {
    return {
      usingMirror: false,
      newlyGotLesson: null,
      transition_name: "window-fade",
      current: {
        problemText: "",
        problem: {
          word: "",
          ja: "",
          difficulty: 3,
        },
      },
      rate: 0.9,
      trainingWindowNotified: false,
      selectedWorkbook: {
        problems: [],
      },
      selectedWorkbookIndex: 0,
      selectedTargetPhoneme: "",
      selectedLesson: null,
      workbookList: {},
      currentWorkbookId: "",
      activeTraining: false,
      showOriginalPron: true,
      sr: null,
      isRecognizing: false,
      speechInfo: null,
      result: {
        modelOutput: null,
        userOutput: null,
        score: null,
      },
      currentModelProns: [],
      userResult: null,
      interimTranscription: "　",
      finalTranscription: "",
      interimVisible: true,
      recordedList: [],
      isUserPlaying: false,
      justSelected: true,
      workbooks: [],
      workbookTitle: "仮のタイトル",
      loadingInstance: null,
      currentWorkbook: null,
      videos: [],
      currentReadingIndex: -1,
      showReadingHighlight: false,
      problemsLoaded: false,
      problemScores: {},
    };
  },
  beforeDestroy() {
    document.removeEventListener("speech-result", this.addResult);
    document.removeEventListener("speech-synthesis-boundary", this.addResult);

    if (this.isRecognizing) {
      this.sr.stopRecog();
    }
    speechRecorder.clearSavedAudios();
  },
  beforeCreate() {
    this.autoNextProb = this.$store.state.autoNextProb;
  },

  mounted() {
    let self = this;

    this.registerShortcutKey();
    this.$store.dispatch("loadAllLessons").then(() => {
      self.loadWorkbooks(this.$route.query.category, false);
    });

    db.collection("users")
      .doc(this.$store.state.auth.user.uid)
      .collection("ProblemResults")
      .doc(this.$route.query.category)
      .get()
      .then((snapshot) => {
        if (snapshot.data()) {
          self.problemScores = snapshot.data();
        }
      });

    document.addEventListener("speech-result", this.addResult);
    document.addEventListener(
      "speech-synthesis-boundary",
      this.highlightPlaying
    );
    // this.fetchScores();

    self.sr = new SpeechRecognizer({
      component: this,
      lang: LANG.EN,
      record: false,
      compare: false,
    });

    document.title = `ネイティブの口 | 発音記号/${this.$route.query.category}/を学ぶレッスンページ`;
  },
  watch: {},
  beforeRouteUpdate(to, from, next) {
    this.selectedWorkbookIndex = 0;
    let self = this;
    self.$refs.video.pause();
    const queryedCategory = to.query.category;
    this.loadWorkbooks(queryedCategory, true);
    document.title = `ネイティブの口 | 発音記号/${queryedCategory}/を学ぶレッスンページ`;

    next();
  },
  methods: {
    resetResult() {
      this.result = {
        modelOutput: null,
        userOutput: null,
        score: null,
      };
    },
    goToNewLesson(lesson) {
      this.$refs.newlyGotLessonModal.closeModal(); // Modal
      this.closeModal(); //training modal
      this.sr.stopRecog();
      let loadingInstance = Loading.service({ fullscreen: true });
      this.$router.push({
        path: "lesson",
        query: { category: lesson.titlePhoneme },
      });
      window.scrollTo(0, 0);
      setTimeout(() => {
        loadingInstance.close();
      }, 1000);
    },
    resumeRecog() {
      this.sr.startRecog();
      this.isRecognizing = true;
    },
    cancelRecog() {
      this.sr.stopRecog();
      this.isRecognizing = false;
    },
    loadWorkbooks(queryedCategory, delay) {
      let loadingInstance;
      this.problemsLoaded = false;

      if (delay) {
        loadingInstance = Loading.service({ fullscreen: true });
      }
      let self = this;
      const video = this.$refs.video;
      if (!queryedCategory) {
        this.$router.replace("/dashboard");
      }
      db.collection("workbooks")
        .where("pron", "==", queryedCategory)
        .get()
        .then((snapshot) => {
          let workbooks = [];
          snapshot.forEach((workbook, index) => {
            workbooks.push(Object.assign(workbook.data(), { id: workbook.id }));
          });
          this.workbookList = workbooks.sort((prev, next) => {
            if (prev.order < next.order) {
              return -1;
            }
            if (prev.order > next.order) {
              return 1;
            }
          });
          setTimeout(() => {
            self.selectWorkbook(self.workbookList[0]);
            self.problemsLoaded = true;
          }, 800);
          if (delay) {
            setTimeout(() => {
              loadingInstance.close();
            }, 1200);
          }
        });

      const selectedLesson = self.$store.state.allLessons.filter((lesson) => {
        return lesson.titlePhoneme === queryedCategory;
      });

      this.selectedLesson = selectedLesson[0];

      if (selectedLesson[0]) {
        const videoIds = selectedLesson[0].videos;

        const score = this.$store.state.userData.totalScore;
        const needed = this.selectedLesson.neededScore;
        if (score < needed && !this.$store.state.userData.unlock) {
          this.$router.replace("/dashboard");
          this.$notify.error({
            title: "エラー",
            message: "権限の無いページへの遷移を検出しました",
          });
        }

        const selectedVideos = [];
        videoIds.forEach((id) => {
          videos.forEach((video) => {
            if (video.id === id) {
              selectedVideos.push(video);
            }
          });
        });
        this.videos = selectedVideos;

        this.$refs.video.loadVideo();
      } else {
        this.$router.replace("/dashboard");
        this.$notify.error({
          title: "エラー",
          message: "レッスンページは存在しません",
        });
      }
    },
    registerShortcutKey() {
      let self = this;
      window.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") {
          self.switchToProb("next");
        }
        if (e.key === "ArrowLeft") {
          self.switchToProb("prev");
        }
      });
    },

    createTitle({ position, phoneme }) {
      let title = "";
      const positionMapping = {
        first: "語頭",
        middle: "語中",
        last: "語末",
        sentence: "熟語・短文・文章",
      };
      if (position !== "sentence" && position && phoneme) {
        title = `/${phoneme}/が${positionMapping[position]}にくる単語`;
      } else if (position === "sentence" && position && phoneme) {
        title = `/${phoneme}/を含む熟語・短文・文章`;
      }
      return title;
    },
    onCameraError() {
      this.$refs.video.toggleMirror();
      this.usingMirror = false;
    },
    enableMirror() {
      this.$refs.video.toggleMirror();
      this.usingMirror = !this.usingMirror;
    },

    selectWorkbook(workbook, index, id) {
      this.selectedWorkbook = workbook;
    },
    back() {
      this.$router.go(-1);
    },
    goToOtherLessonPage(phoneme) {
      this.closeModal();
      this.$router.push({ path: "lesson", query: { category: phoneme } });

      // this.$SmoothScroll(document.querySelector("#top"), 1000, null, null, "y");

      document.title = `ネイティブの口 | 発音記号/${this.$route.query.category}/を学ぶレッスンページ`;
    },
    setDefaultRate() {
      this.rate = 1;
    },
    speak() {
      SpeechSynthesizer.speak({
        text: this.current.problemText,
        rate: this.rate,
        sr: this.sr,
      });
    },
    hasSpace(str) {
      return str.indexOf(" ") >= 0;
    },

    playLatestAudio() {
      const self = this;
      if (!self.isUserPlaying) {
        this.sr.stopOnlyRecog();
        const audio = new Audio(
          URL.createObjectURL(this.speechInfo.detail.audio)
        );
        const offset = this.speechInfo.detail.offsetDuration;
        audio.currentTime = offset / 1000 - 0.8;
        setTimeout(() => {
          audio.play();
          self.isUserPlaying = true;
          self.sr.stopOnlyRecog();
        });

        audio.addEventListener("ended", () => {
          self.isUserPlaying = false;
          self.isRecognizing = false;
          self.sr.startRecog();
          self.isRecognizing = true;
        });
      }
    },

    highlightPlaying(event) {
      const detail = event.detail;
      if (detail.type === "start") {
        this.showReadingHighlight = true;
      }
      if (detail.charLength > 0) {
        this.currentReadingIndex++;
      }
      if (detail.type === "end") {
        this.showReadingHighlight = false;
        this.currentReadingIndex = -1;
      }
    },
    /*
        Callback emitted after receiving speech result
    */
    async addResult(result) {
      let self = this;
      if (result.detail.isFinal) {
        const text = result.detail.textOriginal;
        const savedProblemText = self.current.problemText;
        self.interimVisible = false;
        self.result.score = 0;
        self.interimTranscription = "　";
        self.speechInfo = result;
        pronDict
          .compareSymbolFromTexts(self.current.problemText, text)
          .then(async (r) => {
            // const finalScore =
            //   r.score * 0.8 + result.detail.confidence * 100 * 0.2;

            let finalScore;
            if (r.score >= 80) {
              finalScore =
                Math.ceil(
                  result.detail.confidence * 100 * 0.2 + r.score * 0.8
                ) || 0;
            } else {
              finalScore = Math.ceil(r.score);
            }
            let showResult = r;
            r.score = finalScore;
            self.result = showResult;
            const cleared = finalScore >= 80;

            if (cleared) {
              correctSE.play();
              self.finalTranscription = savedProblemText;
            } else {
              incorrectSE.play();
              self.finalTranscription = result.detail.textOriginal;
            }
            if (cleared && self.autoNextProb) {
              setTimeout(() => {
                self.switchToProb("next");
              }, 700);
            }
            // const storageRef = storage.ref();
            // const audioRef = storageRef.child(
            //   `recorded/${result.detail.textOriginal}`
            // );
            // const uploadResult = await audioRef.put(result.detail.audio);
            var functions = firebase.functions();
            const addResult = firebase.functions().httpsCallable("addResult");

            addResult({
              type: "training",
              text: self.current.problem.word,
              userText: text,
              score: finalScore,
              pron: self.selectedWorkbook.pron,
              prevMaxScore: self.problemScores[self.current.problemText] || 0,
              workbookId: self.selectedWorkbook.id,
              confidence: result.detail.confidence,
              // audioUrl: uploadResult.metadata.fullPath
            })
              .then((result) => {
                // self.$store.commit("incrementTotalScore", finalScore);
                const prevScore =
                  self.$store.state.userData.totalScore - finalScore;
                const nextScore = self.$store.state.userData.totalScore;
                self.$store.state.allLessons.forEach((lesson) => {
                  if (
                    lesson.neededScore > prevScore &&
                    nextScore >= lesson.neededScore &&
                    !self.$store.state.userData.unlock
                  ) {
                    self.newlyGotLesson = lesson;
                    self.$refs.newlyGotLessonModal.showModal();
                    self.$confetti.start({
                      defaultSize: 8,
                      particlesPerFrame: 1,
                      defaultDropRate: 7,
                      particles: [
                        {
                          type: "rect",
                        },
                      ],
                      defaultColors: ["#ddd", "#f55", "#f88", "#fef7ea"],
                    });
                    setTimeout(() => {
                      self.$confetti.stop();
                    }, 5000);
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
            if (
              self.problemScores[self.current.problemText] === undefined || // first try or ..
              self.problemScores[self.current.problemText] < finalScore // better than previous
            ) {
              self.$set(
                self.problemScores,
                self.current.problemText,
                finalScore
              );
            }
          });
      } else {
        self.interimVisible = true;
        self.interimTranscription = result.detail.textOriginal;
      }
    },

    switchToProb(position) {
      const lastProb =
        this.current.index === this.selectedWorkbook.problems.length - 1;
      if (position === "next" && !lastProb) {
        this.transition_name = "window-next";
        const index = this.current.index + 1;
        const workbook = this.selectedWorkbook;
        setTimeout(() => {
          this.activeTraining = false;
          this.transition_name = "window-next";
          this.interimTranscription = "　";
          this.finalTranscription = " ";
          this.result.score = 0;
        }, 100);
        const problem = this.selectedWorkbook.problems[index];
        setTimeout(() => {
          this.showTraining({ problem, workbook, index });
        }, 800);
      }
      const firstProb = this.current.index === 0;

      if (position === "prev" && !firstProb) {
        this.transition_name = "window-prev";
        const index = this.current.index - 1;
        const workbook = this.selectedWorkbook;
        setTimeout(() => {
          this.activeTraining = false;
          this.transition_name = "window-prev";
          this.interimTranscription = "　";
          this.finalTranscription = " ";
          this.result.score = 0;
        }, 100);
        const problem = this.selectedWorkbook.problems[index];
        setTimeout(() => {
          this.showTraining({ problem, workbook, index });
        }, 500);
      }
    },
    showTraining({ problem, workbook, index }) {
      this.resetResult();
      this.current.problemText = problem.word;
      this.currentWorkbook = workbook;
      this.current.problem = problem;
      this.current.index = index;
      this.justSelected = true;
      let self = this;

      this.$refs.video.pause();
      pronDict.getIpaFromSingleText(problem.word).then((result) => {
        self.currentModelProns = result;
        self.activeTraining = true;
        self.sr.startRecog();
        self.isRecognizing = true;
      });

      if (!this.trainingWindowNotified) {
        this.$notify.info({
          title: "トレーニングウィンドウ",
          message: "ウィンドウの外をクリックすると閉じることができます。",
        });
      }
      this.trainingWindowNotified = true;

      setTimeout(() => {
        this.justSelected = false;
      }, 0);

      // self.$refs.scoreComponent.showIcon(iconType.CROSS, 0.8, 110, 2000);
    },
    closeModal() {
      this.transition_name = "window-fade";
      setTimeout(() => {
        this.activeTraining = false;
        this.result.score = null;
        this.sr.stopRecog();
        self.isRecognizing = false;
        // wait until modal animation ends
        setTimeout(() => {
          this.interimTranscription = "　";
          this.finalTranscription = " ";
          this.interimVisible = true;
          this.justSelected = true;
          this.resetUserInputRelated();
        }, 500);
      }, 10);
    },
    resetUserInputRelated() {
      this.$set(this, "result", {
        modelOutput: null,
        userOutput: null,
        score: null,
      });
      this.interimTranscription = "　";
    },
  },
};
</script>

<style lang="scss" scoped>
.icon,
.text {
  vertical-align: middle;
  display: inline-block;
}
.icon {
  width: 50px;
  margin-right: 10px;
  transition: 0.3s ease;
}

.container {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  .back {
    border-radius: 50%;
    cursor: pointer;
    position: fixed;
    height: 25px;
    width: 25px;
    padding: 10px;
    color: white;
    background-color: #555;
    border: none;
    transform: translateX(-55px);
    font-size: 1.4rem;
    /* left: 100px; */
    top: 30px;
    &:hover {
      background-color: #666;
    }
  }
}

.training-window {
  width: 620px;
  height: 450px;
  font-size: 1.2rem;
  position: relative;
  overflow: visible;
  .switch-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 35px;
    height: 120px;
    background-color: #f88;
    box-shadow: 3px 3px 12px 0 rgba(0, 0, 0, 0.1);
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    transition: transform 0.2s ease;
    &:hover {
      transform: scale(1.1);
    }
    i {
      font-size: 1.3rem;
    }
  }

  .left {
    left: -20px;
  }

  .right {
    right: -20px;
  }

  @include mq(sm) {
    width: 650px;
    height: 450px;
    /* transform: none !important; */
    /* position: absolute !important; */
  }
  @include mq(md) {
    width: 820px;
    height: 500px;
  }

  @include mq(lg) {
    width: 960px;
    height: 600px;
  }

  position: fixed;
  @include dark-shadow;
  line-height: 40px;
  z-index: 1042;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* transform: translateY(20%); */
  margin: auto;
  background-color: rgba(255, 255, 255, 1);
  font-size: 1.9rem;
  font-weight: 600;
  /* transition: all 0.5s ease; */
}

.model-diff {
  margin-top: 5px;
  color: rgba(0, 64, 128, 0.4);
}
.user-diff {
  position: absolute;
  left: 0;
  right: 0;
  top: 72%;
  margin: 0 auto;
  color: rgba(0, 64, 128, 0.4);
}

.close-modal {
  z-index: 220;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.lesson-item-header {
  margin: 20px 0 40px 30px;
  text-align: left;
  .header-inline {
    margin-bottom: 10px;
    .icon {
      width: 40px;
    }
    h2 {
      display: inline-block;
      vertical-align: middle;
      font-size: 1.8rem;
      margin-left: 0.2rem;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  p {
    font-weight: bold;
    margin: 0;
  }
}

h1 {
  font-weight: 700;
  font-size: 2.1rem;
  margin: 5px 0;
  padding-top: 100px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    width: 500px;
    height: 3px;
    background-color: #f88;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.window-inner {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
  line-height: 2.2rem;
  display: flex;
  flex-direction: column;

  div {
    display: flex;

    flex-direction: row;
    .window-left {
      box-sizing: border-box;
      transition: all 0.3s ease;
      flex-basis: 150px;
      min-width: 150px;
      font-size: 0.9rem;
      /* margin: 15px 0; */
      @include flex-centerer-column;
      /* border-right: 1px solid #ddd; */

      @include mq(sm) {
        font-size: 0.9rem;
      }
      @include mq(md) {
        font-size: 0.95rem;
      }

      @include mq(lg) {
        font-size: 1rem;
      }

      .ss-control {
        padding-top: 6px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        img {
          margin: 0 5px;
          width: 15px;
          height: 15px;
        }
        .turtle {
          width: 23px;
          height: 23px;
        }
        .rabbit {
          width: 18px;
          height: 18px;
        }
      }

      img {
        cursor: pointer;
        width: 40px;
        height: 40px;
      }
    }
    .window-right {
      position: relative;
      flex: 1;
      box-sizing: border-box;
      font-size: 1.1rem;
      line-height: 1.3rem;
      /* padding: 10px 20px; */
      text-align: center;

      @include mq(sm) {
        font-size: 1.1rem;
        line-height: 1.3rem;
      }
      @include mq(md) {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      @include mq(lg) {
        font-size: 1.8rem;
      }

      @include flex-centerer-column;
      .listening {
        color: $main-color;
      }
      .waiting {
        color: #ccc;
      }
      .state-indicator {
        position: absolute;
        bottom: 30px;
        right: 20px;
        /* @include centerer; */
        z-index: 0;
        @include flex-centerer-column;
        .spinner {
          transform: scale(1.8);
        }
        .text {
          font-size: 0.8rem;
          position: absolute;
          width: 100px;
          text-align: center;
          @include flex-centerer-row;
          top: 30px;
          z-index: 500;
        }
        .listening {
          color: $main-color;
        }
        .waiting {
          color: #ccc;
        }
      }
    }

    .model-pron {
      margin-right: 0.5rem;
      letter-spacing: -1.1px;
      &:last-child {
        margin: 0;
      }
    }

    .speech-text {
      display: inline-block;
      position: relative;
      letter-spacing: -1px;
      vertical-align: middle;
      text-align: center;

      img {
        cursor: pointer;
        width: 30px;
        height: 30px;
        margin-left: 8px;
        /* position: absolute;
          right: -43px;
          top: 0;
          bottom: 0;
          margin: auto 0; */
      }
    }
  }
}

.bottom-navi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .spinner {
    transform: scale(1.6);
  }
  img {
    cursor: pointer;
    width: 30px;
  }
}

.user {
  position: absolute;
  color: #555;
}
.interim {
  user-select: none;
  color: #ddd;
  filter: blur(2px);
  /* &:after {
    position: absolute;
    top: -1px;
    right: -40px;
    content: "...";
  } */
}

.problem-section-header {
  display: inline-block;
  margin: 36px 0 12px 0;
  top: 450px;
  /* margin-top: 36px; */
  /* margin-bottom: 6px; */
  padding: 12px 24px;
  font-size: 1rem;
  /* border-bottom-right-radius: 4px; */
  background-color: #999;
  color: white;
  z-index: 201;
}

// animations

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.window-fade-enter-active,
.window-fade-leave-active {
  transition: all 0.4s ease;
}
.window-fade-enter,
.window-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

// next

.window-next-enter-active,
.window-next-leave-active {
  transition: all 0.25s ease;
}

.window-next-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.window-next-enter {
  opacity: 0;
  transform: translateX(-30px);
}

// prev
.window-prev-enter-active,
.window-prev-leave-active {
  transition: all 0.25s ease;
}

.window-prev-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
.window-prev-enter {
  opacity: 0;
  transform: translateX(30px);
}

// model play
// play icon

.fade-enter-active {
  transition: all 0.3s ease;
}

.fade-enter {
  opacity: 0;
}

.slide-container {
  width: 50%;
  position: relative;
  .slider {
    width: 100%;
    cursor: pointer;
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: $main-color; /* Green background */
      cursor: pointer;
    }
  }
  /* Mouse-over effects */
  .slider:hover {
  }
}

.slider {
  -webkit-appearance: none;
  appearance: none;
  height: 3px;
  background: rgba(0, 0, 0, 0.15);
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    height: 100%;
    background-color: #f88;
    z-index: 1000;
  }
}

.phoneme {
  cursor: pointer;
  &:hover {
    transform: translateY(-2px);
  }
}

.workbook-type-container {
  font-weight: bold;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0 auto;
  font-size: 0.8rem;

  @include mq(sm) {
    font-size: 0.8rem;
  }
  @include mq(md) {
    font-size: 1rem;
  }
}

.active {
  background-color: #555 !important;
  color: white !important;
}

.workbook-type {
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 12px;
  border-right: 1px solid #ddd;
  background-color: #fff;
  .text {
    vertical-align: middle;
  }

  &:last-child {
    border: none;
  }
  .progress {
  }
  &:hover {
    background-color: #fefefe;
  }
}

.workbook-type-inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.right-control {
  display: inline-block;
  div {
    display: inline-block;
  }
}
.mirror-switch {
  border-radius: 0px 5px 0 0;
  z-index: 206;
  padding: 7px 25px;
  font-size: 0.9rem;
  img {
    margin-left: 3px;
    vertical-align: middle;
    width: 20px;
  }
}

.score {
  display: block;
}

.hide {
  opacity: 0;
}
.show {
  opacity: 1;
}

.gauge {
  transition: all 0.3s ease;
}

h3 {
  font-size: 2.6rem;
  text-transform: uppercase;
  font-weight: 900;
  letter-spacing: 8px;
  margin: 45px 0 10px 0;
  text-align: center;
  position: relative;
  color: #bbb;
}

.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 30px 50px 20px 50px;

  .header {
    div {
      h2 {
        font-size: 2rem;
        margin: 0;
      }

      img {
        width: 40px;
        margin-right: 10px;
      }
    }
    .header-description {
      font-size: 1.1rem;
      font-weight: bold;
    }
  }
  .training-acc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #eee;
    width: 210px;
    height: 90px;
    border-radius: 5px;
    position: relative;
    text-align: center;
    .title {
      border-bottom: 1px solid #eee;
      display: block;
      padding: 0px 0 5px 0;
      width: 100%;
      font-size: 0.9rem;
    }
    .score {
      font-size: 2rem;
      font-weight: 900;
    }
  }
}

.upper-config {
  margin: 30px 30px 0px 20px;
  display: flex;
  justify-content: flex-start;
}

// Synthesize

.current {
  color: #333 !important;
}

.not-current {
  color: #ddd !important;
}

.text-color-transition {
  transition: color 0.06s linear;
}

.sleep {
  opacity: 0.12;
}

.pause-icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 200px;
  height: 200px;
  cursor: pointer;
  z-index: 300;
}
</style>
